import { render, staticRenderFns } from "./HTMLEditor.vue?vue&type=template&id=2c4788ed&"
import script from "./HTMLEditor.vue?vue&type=script&lang=ts&"
export * from "./HTMLEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports